// extracted by mini-css-extract-plugin
export default {"form":"Form_form__0Og09","section":"Form_section__WPxAv","wrapper":"Form_wrapper__9rwsy","group":"Form_group__mm7vL"};